module.exports = __webpack_public_path__ + "img/computervision.c366a184.svg";